<template>
  <component :is="type + 'Add'" v-if="type" ref="addContractModal" />
</template>
<script>
import PowerAdd from './power/Add'
import GasAdd from './gas/Add'
import WaterAdd from './water/Add'
import HeatAdd from './heat/Add'

export default {
  components: {
    PowerAdd,
    GasAdd,
    WaterAdd,
    HeatAdd,
  },
  data() {
    return {
      loading: false,
      type: null,
      edit: false,
      id: null,
    }
  },
  methods: {
    saveContract(e) {
      e.preventDefault()
      this.$refs.addContractModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.addContractModal.errors.any() &&
          !this.$refs.addContractModal.loading
        ) {
          if (this.edit) {
            this.$api
              .post(
                'energetics/edit_contract',
                this.$refs.addContractModal.form,
              )
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-contract')
                this.$root.$emit('reloadEnergeticContractData')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri aktualizovaní hodnôt',
                  timer: 5000,
                })
              })
          } else {
            this.$api
              .post('energetics/add_contract', this.$refs.addContractModal.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('reloadEnergeticContractData')
                this.$root.$emit('modal-hide', 'add-contract')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri pridávaní hodnôt',
                  timer: 5000,
                })
              })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
